import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { ProcessingStatusModel, ProcessingStatusModelDetails } from './processing-status-models-model';

@Injectable({
  providedIn: 'root'
})
export class ProcessingStatusModelService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getProcessingStatusModels(): Observable<ProcessingStatusModel[]> {
    return this.appServerAPI.execute('/client/admin/processing-status-model', {});
  }

  public getProcessingStatusModelDetails(statusModelId: number): Observable<ProcessingStatusModelDetails> {
    return this.appServerAPI.execute('/client/admin/processing-status-model/details', statusModelId);
  }

  public save(details: ProcessingStatusModelDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/processing-status-model/save', details);
  }

  public delete(statusModelId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/processing-status-model/delete', statusModelId);
  }

}
